export default {
    "webapp_version": 1,
    "menus": {
        "footer": [],
        "main": [
            {
                "icon_id": "Das Projekt",
                "weight": -50,
                "title": "Das Projekt",
                "is_external": false,
                "internal_path": "/node/39",
                "alias": "/gesamtprojekt",
                "children": [
                    {
                        "icon_id": null,
                        "weight": -50,
                        "title": "Gesamtprojekt",
                        "is_external": false,
                        "internal_path": "/node/39",
                        "alias": "/gesamtprojekt"
                    },
                    {
                        "icon_id": null,
                        "weight": -48,
                        "title": "Projektleitungsteam",
                        "is_external": false,
                        "internal_path": "/node/127",
                        "alias": "/projektleitungsteam"
                    },
                    {
                        "icon_id": null,
                        "weight": -47,
                        "title": "Innerst\u00e4dtischer Bereich / Tunnel",
                        "is_external": false,
                        "internal_path": "/node/40",
                        "alias": "/innenstaedtischer-bereich-tunnel"
                    },
                    {
                        "icon_id": null,
                        "weight": -46,
                        "title": "Netzerg\u00e4nzende Ma\u00dfnahmen",
                        "is_external": false,
                        "internal_path": "/node/105",
                        "alias": "/uebersicht-netzergaenzende-massnahmen"
                    },
                    {
                        "icon_id": null,
                        "weight": 0,
                        "title": "Tangierende Projekte",
                        "is_external": false,
                        "internal_path": "/node/414",
                        "alias": "/tangierende-projekte",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/414",
                                "alias": "/tangierende-projekte"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Technik M\u00fcnchen Hbf",
                                "is_external": false,
                                "internal_path": "/node/145",
                                "alias": "/empfangsgebaeude-hauptbahnhof"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "U-Bahn-Linie U9",
                                "is_external": false,
                                "internal_path": "/node/193",
                                "alias": "/u-bahn-linie-u9"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "ESTW MOP",
                                "is_external": false,
                                "internal_path": "/node/192",
                                "alias": "/estw-mop"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Erweiterung S-Bahn-Abstellanlage Steinhausen",
                                "is_external": false,
                                "internal_path": "/node/143",
                                "alias": "/abstellanlage-steinhausen"
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "Weitere Projekte",
                                "is_external": false,
                                "internal_path": "/node/191",
                                "alias": "/weitere-projekte"
                            }
                        ]
                    }
                ]
            },
            {
                "icon_id": "Arbeitsgebiete",
                "weight": -49,
                "title": "Organisationseinheiten",
                "is_external": false,
                "internal_path": "/node/129",
                "alias": "/organisationseinheiten-uebersicht",
                "children": [
                    {
                        "icon_id": null,
                        "weight": 1,
                        "title": "Organisationseinheiten \u00dcbersicht",
                        "is_external": false,
                        "internal_path": "/node/129",
                        "alias": "/organisationseinheiten-uebersicht"
                    },
                    {
                        "icon_id": null,
                        "weight": 2,
                        "title": "Projekt 2. S-Bahn-Stammstrecke M\u00fcnchen",
                        "is_external": false,
                        "internal_path": "/node/99",
                        "alias": "/uebersicht-projekt-2sbss",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/99",
                                "alias": "/uebersicht-projekt-2sbss"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Teamorganisation",
                                "is_external": false,
                                "internal_path": "/node/416",
                                "alias": "/teamorganisation-2sbss"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Kommunikationsziele",
                                "is_external": false,
                                "internal_path": "/node/24",
                                "alias": "/kommunikationsziele"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Kernbotschaften",
                                "is_external": false,
                                "internal_path": "/node/25",
                                "alias": "/kernbotschaften"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Kommunikationsstrategie",
                                "is_external": false,
                                "internal_path": "/node/26",
                                "alias": "/kommunikationsstrategie"
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "Infozentrum",
                                "is_external": false,
                                "internal_path": "/node/37",
                                "alias": "/infozentrum"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 3,
                        "title": "I.IIM 1 - Vertrags- und Nachtragsmanagement",
                        "is_external": false,
                        "internal_path": "/node/406",
                        "alias": "/vertrags-und-nachtragsmanagement",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/406",
                                "alias": "/vertrags-und-nachtragsmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Teamorganisation",
                                "is_external": false,
                                "internal_path": "/node/412",
                                "alias": "/teamorganisation-vertrags-und-nachtragsmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Aufgaben und Funktionen",
                                "is_external": false,
                                "internal_path": "/node/407",
                                "alias": "/aufgaben-und-funktionen-vertrags-nachtragsmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Projektbeteiligte",
                                "is_external": false,
                                "internal_path": "/node/413",
                                "alias": "/projektbeteiligte-vertrags-und-nachtragsmanagement"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 4,
                        "title": "I.IIM 2 - Projektsteuerung",
                        "is_external": false,
                        "internal_path": "/node/277",
                        "alias": "/projektsteuerung",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/277",
                                "alias": "/projektsteuerung"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "OE-Beschreibung",
                                "is_external": false,
                                "internal_path": "/node/278",
                                "alias": "/oe-beschreibung-projektsteuerung"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Teamorganisation",
                                "is_external": false,
                                "internal_path": "/node/279",
                                "alias": "/teamorganisation-projektsteuerung"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Aufgaben und Funktionen",
                                "is_external": false,
                                "internal_path": "/node/280",
                                "alias": "/aufgaben-und-funktionen-projektsteuerung"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Projektbeteiligte",
                                "is_external": false,
                                "internal_path": "/node/281",
                                "alias": "/projektbeteiligte-projektsteuerung"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 5,
                        "title": "I.IIM 3 - Zentrale Aufgaben",
                        "is_external": false,
                        "internal_path": "/node/393",
                        "alias": "/zentrale-aufgaben",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/393",
                                "alias": "/zentrale-aufgaben"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Teamorganisation",
                                "is_external": false,
                                "internal_path": "/node/388",
                                "alias": "/teamorganisation-zentrale-aufgaben"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Teams & Aufgabenbereiche",
                                "is_external": false,
                                "internal_path": "/node/392",
                                "alias": "/teams-&-aufgabenbereiche"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Projektbeteiligte",
                                "is_external": false,
                                "internal_path": "/node/389",
                                "alias": "/projektbeteiligte-zentrale-aufgaben"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 6,
                        "title": "I.IIM 4 - Portfolioprojekte, Bahntechnik und -koordination",
                        "is_external": false,
                        "internal_path": "/node/409",
                        "alias": "/portfolioprojekte-bahntechnik",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/409",
                                "alias": "/portfolioprojekte-bahntechnik"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "I.IIM 41 - Rangierbahnhof Nord",
                                "is_external": false,
                                "internal_path": "/node/430",
                                "alias": "/uebersicht-rangierbahnhof-nord",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/430",
                                        "alias": "/uebersicht-rangierbahnhof-nord"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/431",
                                        "alias": "/projektbeschreibung-rangierbahnhof-nord"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/432",
                                        "alias": "/projektbeteiligte-rangierbahnhof-nord"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/433",
                                        "alias": "/besprechungen-rangierbahnhof-nord"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "I.IIM 41 - NeM 07: Markt Schwaben Zus\u00e4tzlicher Bahnsteig (Gleis 5)",
                                "is_external": false,
                                "internal_path": "/node/89",
                                "alias": "/uebersicht-ba71",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/89",
                                        "alias": "/uebersicht-ba71"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/57",
                                        "alias": "/projektbeschreibung-ba-71"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/209",
                                        "alias": "/teamorganisation-ba71-nem07-schwaben"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/258",
                                        "alias": "/projektbeteiligte-ba71"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/324",
                                        "alias": "/besprechungen-ba71"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 6,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/316",
                                        "alias": "/technische-projektstruktur-nem07"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "I.IIM 41 - NeM 08: Begegnungsabschnitt St. Koloman - Aufhausen",
                                "is_external": false,
                                "internal_path": "/node/90",
                                "alias": "/uebersicht-ba72",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/90",
                                        "alias": "/uebersicht-ba72"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/58",
                                        "alias": "/projektbeschreibung-ba72"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/210",
                                        "alias": "/teamorganisation-ba72-nem08-kolomann-aufhausen"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/259",
                                        "alias": "/projektbeteiligte-ba72"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/325",
                                        "alias": "/besprechungen-ba72"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/317",
                                        "alias": "/technische-projektstruktur-nem08"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "I.IIM 41 - NeM 13: Niveaufreie Verzweigung M\u00fcnchen-Westkreuz",
                                "is_external": false,
                                "internal_path": "/node/91",
                                "alias": "/uebersicht-ba73",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/91",
                                        "alias": "/uebersicht-ba73"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/59",
                                        "alias": "/projektbeschreibung-ba73"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/211",
                                        "alias": "/teamorganisation-ba73-muenchen-westkreuz"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/260",
                                        "alias": "/projektbeteiligte-ba73"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/326",
                                        "alias": "/besprechungen-ba73"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/318",
                                        "alias": "/technische-projektstruktur-nem13"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "I.IIM 41 - NeM 16: Neubau Abstell- und Wendegleis We\u00dfling",
                                "is_external": false,
                                "internal_path": "/node/92",
                                "alias": "/uebersicht-ba74",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/92",
                                        "alias": "/uebersicht-ba74"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/60",
                                        "alias": "/projektbeschreibung-ba-74"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/212",
                                        "alias": "/teamorganisation-ba74-wessling"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/261",
                                        "alias": "/projektbeteiligte-ba74"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 6,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/327",
                                        "alias": "/besprechungen-ba74"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 7,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/319",
                                        "alias": "/technische-projektstruktur-nem16"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "I.IIM 41 - NeM: 17: Zweigleisigkeit Steinebach - Seefeld-Hechendorf",
                                "is_external": false,
                                "internal_path": "/node/93",
                                "alias": "/uebersicht-ba75",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/93",
                                        "alias": "/uebersicht-ba75"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/61",
                                        "alias": "/projektbeschreibung-ba-75"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/213",
                                        "alias": "/teamorganisation-ba75-steinbach-seefeld-hechendorf"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/262",
                                        "alias": "/projektbeteiligte-ba75"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/328",
                                        "alias": "/besprechungen-ba75"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 6,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/320",
                                        "alias": "/technische-projektstruktur-nem17"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 8,
                                "title": "I.IIM 41 - NeM 23: Fahrzeitverk\u00fcrzung Johanneskirchen \u2013 Flughafen",
                                "is_external": false,
                                "internal_path": "/node/95",
                                "alias": "/uebersicht-ba77",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/95",
                                        "alias": "/uebersicht-ba77"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/170",
                                        "alias": "/projektbeschreibung-ba77-nem23"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/215",
                                        "alias": "/teamorganisation-ba77-johanneskirchen-flughafen"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/264",
                                        "alias": "/Projektbeteiligte-ba77"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/330",
                                        "alias": "/besprechungen-ba77"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/322",
                                        "alias": "/technische-projektstruktur-nem23"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 9,
                                "title": "I.IIM 42 - Bahntechnik",
                                "is_external": false,
                                "internal_path": "/node/96",
                                "alias": "/uebersicht-bahntechnik",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/96",
                                        "alias": "/uebersicht-bahntechnik"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "OE-Beschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/85",
                                        "alias": "/oe-beschreibung-bahntechnik"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/268",
                                        "alias": "/teamorganisation-bahntechnik"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Aufgaben und Funktionen",
                                        "is_external": false,
                                        "internal_path": "/node/293",
                                        "alias": "/aufgaben-und-funktionen-bahntechnik"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/267",
                                        "alias": "/projektbeteiligte-bahntechnik"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/269",
                                        "alias": "/besprechungen-bahntechnik"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 10,
                                "title": "I.IIM 43 - Bahnkoordination",
                                "is_external": false,
                                "internal_path": "/node/419",
                                "alias": "/uebersicht-bahnkoordination",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/419",
                                        "alias": "/uebersicht-bahnkoordination"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "OE-Beschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/423",
                                        "alias": "/oe-beschreibung-bahnkoordination"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/420",
                                        "alias": "/teamorganisation-bahnkoordination"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Aufgaben und Funktionen",
                                        "is_external": false,
                                        "internal_path": "/node/425",
                                        "alias": "/aufgaben-und-funktionen-bahnkoordination"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/422",
                                        "alias": "/projektbeteiligte-bahnkoordination"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/424",
                                        "alias": "/besprechungen-bahnkoordination"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "icon_id": "Arbeitsgebiete",
                        "weight": 7,
                        "title": "I.IIM 5 - Technik 2.SBSS",
                        "is_external": false,
                        "internal_path": "/node/410",
                        "alias": "/technik-2sbss",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/410",
                                "alias": "/technik-2sbss"
                            },
                            {
                                "icon_id": null,
                                "weight": 7,
                                "title": "I.IIM 51 - BA 10 - Technik Oberirdisch West + Umweltverbundr\u00f6hre (UVR)",
                                "is_external": false,
                                "internal_path": "/node/48",
                                "alias": "/uebersicht-ba-10",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/48",
                                        "alias": "/uebersicht-ba-10"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/49",
                                        "alias": "/projektbeschreibung-ba10"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/439",
                                        "alias": "/teamorganisation-ba10-oberirdisch-west"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/252",
                                        "alias": "/projektbeteiligte-ba10"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/64",
                                        "alias": "/besprechungen-ba10"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/244",
                                        "alias": "/technische-Projektstruktur-ba10"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 8,
                                "title": "I.IIM 52 - BA 20 - Technik Unterirdisch West",
                                "is_external": false,
                                "internal_path": "/node/80",
                                "alias": "/uebersicht-ba-20",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/80",
                                        "alias": "/uebersicht-ba-20"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/50",
                                        "alias": "/projektbeschreibung-ba-20"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/206",
                                        "alias": "/teamorganisation-ba20-unterirdisch-west-hbf"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/253",
                                        "alias": "/projektbeteiligte-ba20"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/65",
                                        "alias": "/besprechungen-ba20"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 6,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/197",
                                        "alias": "/technische-projektstruktur-ba20"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 9,
                                "title": "I.IIM 53 - BA 30 - Technik Marienhof",
                                "is_external": false,
                                "internal_path": "/node/81",
                                "alias": "/uebersicht-ba-30",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/81",
                                        "alias": "/uebersicht-ba-30"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/53",
                                        "alias": "/projektbeschreibung-ba-30"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/207",
                                        "alias": "/teamorganisation-ba30-marienhof"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/254",
                                        "alias": "/projektbeteiligte-ba30"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 6,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/66",
                                        "alias": "/besprechungen-ba30"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 7,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/246",
                                        "alias": "/technische-projektstruktur-ba30"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 11,
                                "title": "I.IIM 54 - BA 55 - Technik Projektabschnitt Ost",
                                "is_external": false,
                                "internal_path": "/node/83",
                                "alias": "/uebersicht-ba-55",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/83",
                                        "alias": "/uebersicht-ba-55"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "Projektbeschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/55",
                                        "alias": "/projektbeschreibung-ba55"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/204",
                                        "alias": "/teamorganisation-ba55"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 3,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/256",
                                        "alias": "/projektbeteiligte-ba55"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/63",
                                        "alias": "/besprechungen-ba55"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Technische Projektstruktur",
                                        "is_external": false,
                                        "internal_path": "/node/248",
                                        "alias": "/technische-projektstruktur-ba55"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 6,
                                        "title": "Allianz VE 734",
                                        "is_external": false,
                                        "internal_path": "/node/435",
                                        "alias": "/Allianz-VE-734-projektabschnitt-ost"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 12,
                                "title": "I.IIM 55 - Technisches Projektmanagement",
                                "is_external": false,
                                "internal_path": "/node/98",
                                "alias": "/uebersicht-technisches-projektmanagement",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 0,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/98",
                                        "alias": "/uebersicht-technisches-projektmanagement"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 1,
                                        "title": "OE-Beschreibung",
                                        "is_external": false,
                                        "internal_path": "/node/86",
                                        "alias": "/oe-beschreibung-technisches-projektmanagement"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 2,
                                        "title": "Teamorganisation",
                                        "is_external": false,
                                        "internal_path": "/node/208",
                                        "alias": "/teamorganisation-technisches-projektmanagement"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "Projektbeteiligte",
                                        "is_external": false,
                                        "internal_path": "/node/266",
                                        "alias": "/projektbeteiligte-technisches-projektmanagement"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Besprechungen",
                                        "is_external": false,
                                        "internal_path": "/node/68",
                                        "alias": "/besprechungen-technisches-projektmanagement"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "icon_id": "Arbeitsgebiete",
                        "weight": 9,
                        "title": "I.IIM 6 - Technik M\u00fcnchen Hbf",
                        "is_external": false,
                        "internal_path": "/node/436",
                        "alias": "/technik-muenchen-hbf",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/436",
                                "alias": "/technik-muenchen-hbf"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "I.IIM 6 - Technik M\u00fcnchen Hbf - \u00dcbergreifende Themen",
                                "is_external": false,
                                "internal_path": "/node/442",
                                "alias": "/technik-muenchen-hbf-uebergreifende-themen"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Projektbeschreibung I.IIM 6 - \u00dcbergreifende Themen",
                                "is_external": false,
                                "internal_path": "/node/461",
                                "alias": "/projektbeschreibung-I.IIM-6-Uebergreifende-Themen"
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "I.IIM 61 - Technik Hbf SF Hochbau",
                                "is_external": false,
                                "internal_path": "/node/441",
                                "alias": "/technik-hbf-sf-hochbau",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 4,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/441",
                                        "alias": "/technik-hbf-sf-hochbau"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 5,
                                        "title": "Projektbeschreibung I.IIM 61 - Technik Hbf SF Hochbau",
                                        "is_external": false,
                                        "internal_path": "/node/440",
                                        "alias": "/projektbeschreibung-I.IIM-61-technik-hbf-sf-hochbau"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 6,
                                        "title": "Teamorganisation I.IIM 61 - Technik Hbf SF Hochbau",
                                        "is_external": false,
                                        "internal_path": "/node/203",
                                        "alias": "/node/203"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 7,
                                        "title": "Projektbeteiligte I.IIM 61",
                                        "is_external": false,
                                        "internal_path": "/node/437",
                                        "alias": "/projektbeteiligte-I.IIM-61"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 8,
                                        "title": "Besprechungen I.IIM 61",
                                        "is_external": false,
                                        "internal_path": "/node/438",
                                        "alias": "/besprechungen-I.IIM-61"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 9,
                                        "title": "Technische Projektstruktur I.IIM 61",
                                        "is_external": false,
                                        "internal_path": "/node/443",
                                        "alias": "/technische-projektstruktur-I.IIM-61"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 7,
                                "title": "I.IIM 62 - Technik Hbf Projektkoordination",
                                "is_external": false,
                                "internal_path": "/node/458",
                                "alias": "/technik-hbf-projektkoordination",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 11,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/451",
                                        "alias": "/node/451"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 12,
                                        "title": "Projektbeschreibung I.IIM 62 - Technik Hbf Projektkoordination",
                                        "is_external": false,
                                        "internal_path": "/node/446",
                                        "alias": "/projektbeschreibung-I.IIM-62-technik-hbf-projektkoordination"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 13,
                                        "title": "Teamorganisation I.IIM 62 - Technik Hbf Projektkoordination",
                                        "is_external": false,
                                        "internal_path": "/node/447",
                                        "alias": "/teamorganisation-I.IIM-62-technik-hbf-projektkoordination"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 14,
                                        "title": "Projektbeteiligte I.IIM 62",
                                        "is_external": false,
                                        "internal_path": "/node/449",
                                        "alias": "/projektbeteiligte-I.IIM-62"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 15,
                                        "title": "Besprechungen I.IIM 62",
                                        "is_external": false,
                                        "internal_path": "/node/448",
                                        "alias": "/besprechungen-I.IIM-62"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 16,
                                        "title": "Technische Projektstruktur I.IIM 62",
                                        "is_external": false,
                                        "internal_path": "/node/444",
                                        "alias": "/technische-projektstruktur-I.IIM-62"
                                    }
                                ]
                            },
                            {
                                "icon_id": null,
                                "weight": 8,
                                "title": "I.IIM 63 - Technik Hbf Ingenieurbau",
                                "is_external": false,
                                "internal_path": "/node/459",
                                "alias": "/node/459",
                                "children": [
                                    {
                                        "icon_id": null,
                                        "weight": 12,
                                        "title": "\u00dcbersicht",
                                        "is_external": false,
                                        "internal_path": "/node/455",
                                        "alias": "/technik-hbf-ingenieurbau"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 13,
                                        "title": "Projektbeschreibung I.IIM 63 - Technik Hbf Ingenieurbau",
                                        "is_external": false,
                                        "internal_path": "/node/453",
                                        "alias": "/projektbeschreibung-I.IIM-63-technik-hbf-ingenieurbau"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 14,
                                        "title": "Teamorganisation I.IIM 63 - Technik Hbf Ingenieurbau",
                                        "is_external": false,
                                        "internal_path": "/node/457",
                                        "alias": "/teamorganisation-I.IIM-63-technik-hbf-ingenieurbau"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 15,
                                        "title": "Projektbeteiligte I.IIM 63",
                                        "is_external": false,
                                        "internal_path": "/node/456",
                                        "alias": "/projektbeteiligtenliste-I.IIM-63"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 16,
                                        "title": "Besprechungen I.IIM 63",
                                        "is_external": false,
                                        "internal_path": "/node/454",
                                        "alias": "/besprechungen-I.IIM-63"
                                    },
                                    {
                                        "icon_id": null,
                                        "weight": 17,
                                        "title": "Technische Projektstruktur I.IIM 63",
                                        "is_external": false,
                                        "internal_path": "/node/452",
                                        "alias": "/technische-projektstruktur-I.IIM-63"
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 10,
                        "title": "I.IFI 3 - Kaufm\u00e4nnisches Projektmanagement",
                        "is_external": false,
                        "internal_path": "/node/428",
                        "alias": "/Kaufm\u00e4nnisches-Projektmanagement",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Teamorganisation",
                                "is_external": false,
                                "internal_path": "/node/427",
                                "alias": "/teamorganisation-I.IFI-3-Kaufm\u00e4nnisches-Projektmanagement"
                            }
                        ]
                    }
                ]
            },
            {
                "icon_id": "Technisches PM",
                "weight": -48,
                "title": "Projektmanagement",
                "is_external": false,
                "internal_path": "/node/273",
                "alias": "/projektmanagement",
                "children": [
                    {
                        "icon_id": null,
                        "weight": 1,
                        "title": "Projektmanagement \u00dcbersicht",
                        "is_external": false,
                        "internal_path": "/node/273",
                        "alias": "/projektmanagement"
                    },
                    {
                        "icon_id": null,
                        "weight": 2,
                        "title": "\u00dcbergeordnet",
                        "is_external": false,
                        "internal_path": "/node/297",
                        "alias": "/uebergeordnet"
                    },
                    {
                        "icon_id": null,
                        "weight": 3,
                        "title": "Koordination, Organisation, Dokumentation, QM",
                        "is_external": false,
                        "internal_path": "/node/100",
                        "alias": "/uebersicht-koordination-organisation-dokumentation-qm",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/100",
                                "alias": "/uebersicht-koordination-organisation-dokumentation-qm"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Projektorganisation",
                                "is_external": false,
                                "internal_path": "/node/88",
                                "alias": "/projektorganisation-gesamtorganigramm"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Besprechungsstruktur",
                                "is_external": false,
                                "internal_path": "/node/132",
                                "alias": "/besprechungsstruktur"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Leistungsphasen",
                                "is_external": false,
                                "internal_path": "/node/194",
                                "alias": "/leistungsphasen"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Projektprozesse",
                                "is_external": false,
                                "internal_path": "/node/196",
                                "alias": "/projektprozesse-uebersicht",
                                "children": []
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "Projektdokumentation",
                                "is_external": false,
                                "internal_path": "/node/198",
                                "alias": "/projektdokumentation"
                            },
                            {
                                "icon_id": null,
                                "weight": 7,
                                "title": "Schnittstellenmanagement",
                                "is_external": false,
                                "internal_path": "/node/141",
                                "alias": "/schnittstellenmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 8,
                                "title": "Entscheidungs- und \u00c4nderungsmanagement",
                                "is_external": false,
                                "internal_path": "/node/139",
                                "alias": "/entscheidungs-und-aenderungsmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 9,
                                "title": "M\u00e4ngelmanagement",
                                "is_external": false,
                                "internal_path": "/node/140",
                                "alias": "/maengelmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 10,
                                "title": "Auflagenmanagement Ausf\u00fchrungsplanung",
                                "is_external": false,
                                "internal_path": "/node/372",
                                "alias": "/auflagenmanagement-ausfuehrungsplanung"
                            },
                            {
                                "icon_id": null,
                                "weight": 11,
                                "title": "Reporting Gesamt",
                                "is_external": false,
                                "internal_path": "/node/377",
                                "alias": "/reporting-uebersicht"
                            },
                            {
                                "icon_id": null,
                                "weight": 13,
                                "title": "Quality Gates, Stresstests",
                                "is_external": false,
                                "internal_path": "/node/199",
                                "alias": "/quality-gates-stresstests"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 4,
                        "title": "Kosten und Finanzierung",
                        "is_external": false,
                        "internal_path": "/node/429",
                        "alias": "/uebersicht-kosten-und-finanzierung"
                    },
                    {
                        "icon_id": null,
                        "weight": 5,
                        "title": "Termine",
                        "is_external": false,
                        "internal_path": "/node/131",
                        "alias": "/uebersicht-termine",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/131",
                                "alias": "/uebersicht-termine"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Terminplansystem",
                                "is_external": false,
                                "internal_path": "/node/133",
                                "alias": "/terminplansystem"
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "Terminplanphilosophie",
                                "is_external": false,
                                "internal_path": "/node/270",
                                "alias": "/terminplanphilosophie"
                            },
                            {
                                "icon_id": null,
                                "weight": 7,
                                "title": "Zugang und erste Schritte",
                                "is_external": false,
                                "internal_path": "/node/130",
                                "alias": "/zugang-erste-schritte"
                            },
                            {
                                "icon_id": null,
                                "weight": 8,
                                "title": "Schnittstellen",
                                "is_external": false,
                                "internal_path": "/node/271",
                                "alias": "/schnittstellen"
                            },
                            {
                                "icon_id": null,
                                "weight": 10,
                                "title": "Reporting Termine",
                                "is_external": false,
                                "internal_path": "/node/272",
                                "alias": "/reporting-termine"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 6,
                        "title": "Vertr\u00e4ge / Nachtr\u00e4ge",
                        "is_external": false,
                        "internal_path": "/node/226",
                        "alias": "/uebersicht-vertraege-nachtraege",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/226",
                                "alias": "/uebersicht-vertraege-nachtraege"
                            },
                            {
                                "icon_id": null,
                                "weight": 12,
                                "title": "Vergabestruktur",
                                "is_external": false,
                                "internal_path": "/node/227",
                                "alias": "/vergabestruktur"
                            },
                            {
                                "icon_id": null,
                                "weight": 13,
                                "title": "Hauptvertr\u00e4ge",
                                "is_external": false,
                                "internal_path": "/node/230",
                                "alias": "/hauptvertraege"
                            },
                            {
                                "icon_id": null,
                                "weight": 14,
                                "title": "DB - interne Vertr\u00e4ge",
                                "is_external": false,
                                "internal_path": "/node/231",
                                "alias": "/db-interne-vertraege"
                            },
                            {
                                "icon_id": null,
                                "weight": 15,
                                "title": "Nachtragsmanagement",
                                "is_external": false,
                                "internal_path": "/node/232",
                                "alias": "/nachtragsmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 16,
                                "title": "Abnahmen",
                                "is_external": false,
                                "internal_path": "/node/234",
                                "alias": "/abnahmen"
                            },
                            {
                                "icon_id": null,
                                "weight": 17,
                                "title": "B\u00fcrgschaft / Gew\u00e4hrleistung",
                                "is_external": false,
                                "internal_path": "/node/235",
                                "alias": "/buergschaft-gewaehrleistung"
                            },
                            {
                                "icon_id": null,
                                "weight": 18,
                                "title": "DVA - Versicherung",
                                "is_external": false,
                                "internal_path": "/node/236",
                                "alias": "/dva-versicherung"
                            },
                            {
                                "icon_id": null,
                                "weight": 20,
                                "title": "Claimmanagementsteuerung",
                                "is_external": false,
                                "internal_path": "/node/233",
                                "alias": "/claimmanagementsteuerung"
                            },
                            {
                                "icon_id": null,
                                "weight": 21,
                                "title": "Vergabemanagement",
                                "is_external": false,
                                "internal_path": "/node/228",
                                "alias": "/vergabemanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 22,
                                "title": "Vergabeprozesse",
                                "is_external": false,
                                "internal_path": "/node/229",
                                "alias": "/vergabeprozesse"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 7,
                        "title": "Planlaufmanagement",
                        "is_external": false,
                        "internal_path": "/node/160",
                        "alias": "/uebersicht-planlaufmanagement",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/160",
                                "alias": "/uebersicht-planlaufmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Planlaufmanagementsystem",
                                "is_external": false,
                                "internal_path": "/node/159",
                                "alias": "/planlaufmanagementsystem"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Planpakete",
                                "is_external": false,
                                "internal_path": "/node/156",
                                "alias": "/planpakete"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Plancodierung",
                                "is_external": false,
                                "internal_path": "/node/157",
                                "alias": "/plancodierung"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Planerstellung / Aufgabenplanung",
                                "is_external": false,
                                "internal_path": "/node/158",
                                "alias": "/planerstellung-aufgabenplanung"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 8,
                        "title": "Inbetriebnahmemanagement",
                        "is_external": false,
                        "internal_path": "/node/184",
                        "alias": "/uebersicht-inbetriebnahmemanagement",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/184",
                                "alias": "/uebersicht-inbetriebnahmemanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Allgemeines / Begriffsdefinition",
                                "is_external": false,
                                "internal_path": "/node/179",
                                "alias": "/allgemeines-begriffsdefinition"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Ansprechpartner Inbetriebnahme",
                                "is_external": false,
                                "internal_path": "/node/180",
                                "alias": "/ansprechpartner-inbetriebnahme"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Inbetriebnahmeablauf",
                                "is_external": false,
                                "internal_path": "/node/181",
                                "alias": "/inbetriebnahmeablauf"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 9,
                        "title": "Risikomanagement",
                        "is_external": false,
                        "internal_path": "/node/165",
                        "alias": "/uebersicht-risikomanagement",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/165",
                                "alias": "/uebersicht-risikomanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Ansprechpartner",
                                "is_external": false,
                                "internal_path": "/node/169",
                                "alias": "/ansprechpartner-risikomanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Ablauf Risikomanagement und Risikotool is.base",
                                "is_external": false,
                                "internal_path": "/node/164",
                                "alias": "/ablauf-risikomanagement-und-risikotool-isbase"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Definition der H\u00e4rtegrade",
                                "is_external": false,
                                "internal_path": "/node/166",
                                "alias": "/definition-der-haertegrade"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Zusammensetzung des Risikocodes",
                                "is_external": false,
                                "internal_path": "/node/167",
                                "alias": "/zusammensetzung-des-risikocodes"
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "Risikobesprechungen",
                                "is_external": false,
                                "internal_path": "/node/168",
                                "alias": "/risikobesprechungen"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 10,
                        "title": "Lean Management",
                        "is_external": false,
                        "internal_path": "/node/188",
                        "alias": "/uebersicht-leanmanagement",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/188",
                                "alias": "/uebersicht-leanmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Allgemeines Lean Management",
                                "is_external": false,
                                "internal_path": "/node/185",
                                "alias": "/allgemeines-leanmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Organisation",
                                "is_external": false,
                                "internal_path": "/node/186",
                                "alias": "/organisation-leanmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Methoden Lean Management",
                                "is_external": false,
                                "internal_path": "/node/187",
                                "alias": "/methoden-leanmangement"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Team Lean Management",
                                "is_external": false,
                                "internal_path": "/node/189",
                                "alias": "/berichte-leanmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Vorlagen/Dokumente",
                                "is_external": false,
                                "internal_path": "/node/418",
                                "alias": "/vorlagen-dokumente"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 11,
                        "title": "Bau\u00fcberwachung",
                        "is_external": false,
                        "internal_path": "/node/177",
                        "alias": "/uebersicht-buw",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/177",
                                "alias": "/uebersicht-buw"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Sekund\u00e4re B\u00dcW und operative Qualit\u00e4t",
                                "is_external": false,
                                "internal_path": "/node/417",
                                "alias": "/sekundaere-buew-operative-qualitaet"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Verantwortlichkeiten",
                                "is_external": false,
                                "internal_path": "/node/173",
                                "alias": "/verantwortlichkeiten-buw"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Bautagebuch",
                                "is_external": false,
                                "internal_path": "/node/176",
                                "alias": "/bautagebuch"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 12,
                        "title": "Verfahrensmanagement",
                        "is_external": false,
                        "internal_path": "/node/355",
                        "alias": "/uebersicht-verfahrensmanagement",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/355",
                                "alias": "/uebersicht-verfahrensmanagement"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Allgemeines / Organisationsprinzip",
                                "is_external": false,
                                "internal_path": "/node/354",
                                "alias": "/verfahrensmanagement-organisationsprinzip"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Aufgaben des Verfahrensmanagements",
                                "is_external": false,
                                "internal_path": "/node/351",
                                "alias": "/verfahrensmanagement-aufgaben"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Organisation des Verfahrensmanagements",
                                "is_external": false,
                                "internal_path": "/node/361",
                                "alias": "/verfahrensmanagement-organisation"
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "Ansprechpartner Verfahrensmanagement",
                                "is_external": false,
                                "internal_path": "/node/349",
                                "alias": "/verfahrensmanagement-ansprechpartner"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 13,
                        "title": "Projektbeteiligte",
                        "is_external": false,
                        "internal_path": "/node/331",
                        "alias": "/projektbeteiligtenliste"
                    }
                ]
            },
            {
                "icon_id": "RZ",
                "weight": -47,
                "title": "Realisierungszentrum",
                "is_external": false,
                "internal_path": "/node/17",
                "alias": "/das-realisierungszentrum",
                "children": [
                    {
                        "icon_id": null,
                        "weight": -93,
                        "title": "Das Realisierungszentrum",
                        "is_external": false,
                        "internal_path": "/node/17",
                        "alias": "/das-realisierungszentrum"
                    },
                    {
                        "icon_id": null,
                        "weight": -92,
                        "title": "Teamorganisation RZ",
                        "is_external": false,
                        "internal_path": "/node/18",
                        "alias": "/teamorganisation-rz"
                    },
                    {
                        "icon_id": null,
                        "weight": -91,
                        "title": "Unsere Leistungen",
                        "is_external": false,
                        "internal_path": "/node/15",
                        "alias": "/unsere-leistungen"
                    },
                    {
                        "icon_id": null,
                        "weight": -90,
                        "title": "Unsere Tools",
                        "is_external": false,
                        "internal_path": "/node/22",
                        "alias": "/unsere-tools"
                    },
                    {
                        "icon_id": null,
                        "weight": -88,
                        "title": "Ihr Weg zu uns",
                        "is_external": false,
                        "internal_path": "/node/16",
                        "alias": "/ihr-weg-zu-uns"
                    },
                    {
                        "icon_id": null,
                        "weight": -87,
                        "title": "Kontakt",
                        "is_external": false,
                        "internal_path": "/node/19",
                        "alias": "/kontakt"
                    }
                ]
            },
            {
                "icon_id": "Arbeitsplatz",
                "weight": -44,
                "title": "Arbeitsplatz RZ",
                "is_external": false,
                "internal_path": "/node/106",
                "alias": "/arbeitsplatz-rz-uebersicht",
                "children": [
                    {
                        "icon_id": null,
                        "weight": 0,
                        "title": "Arbeitsplatz RZ \u00dcbersicht",
                        "is_external": false,
                        "internal_path": "/node/106",
                        "alias": "/arbeitsplatz-rz-uebersicht"
                    },
                    {
                        "icon_id": null,
                        "weight": 1,
                        "title": "Allgemeine Abl\u00e4ufe",
                        "is_external": false,
                        "internal_path": "/node/107",
                        "alias": "/allgemeine-ablaeufe"
                    },
                    {
                        "icon_id": null,
                        "weight": 2,
                        "title": "Verantwortlichkeiten",
                        "is_external": false,
                        "internal_path": "/node/108",
                        "alias": "/verantwortlichkeiten-rz"
                    },
                    {
                        "icon_id": null,
                        "weight": 3,
                        "title": "Arbeitssicherheit und Umweltschutz",
                        "is_external": false,
                        "internal_path": "/node/109",
                        "alias": "/arbeitssicherheit-und-umweltschutz"
                    },
                    {
                        "icon_id": null,
                        "weight": 4,
                        "title": "Compliance",
                        "is_external": false,
                        "internal_path": "/node/110",
                        "alias": "/compliance-rz"
                    },
                    {
                        "icon_id": null,
                        "weight": 5,
                        "title": "Datenschutz",
                        "is_external": false,
                        "internal_path": "/node/111",
                        "alias": "/datenschutz-rz"
                    },
                    {
                        "icon_id": null,
                        "weight": 6,
                        "title": "Der Arbeitsplatz",
                        "is_external": false,
                        "internal_path": "/node/112",
                        "alias": "/einrichtung-rz",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "Arbeitsplatz \u00dcbersicht RZ",
                                "is_external": false,
                                "internal_path": "/node/343",
                                "alias": "/der-arbeitsplatz-rz"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "Einrichtung",
                                "is_external": false,
                                "internal_path": "/node/112",
                                "alias": "/einrichtung-rz"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "Mobiles Arbeiten",
                                "is_external": false,
                                "internal_path": "/node/116",
                                "alias": "/mobiles-arbeiten-rz"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "Arbeitszeiterfassung / Urlaub / \u00dcberzeit / Krankmeldung / FAA",
                                "is_external": false,
                                "internal_path": "/node/117",
                                "alias": "/arbeitszeiterfassung-urlaub-ueberzeit-krankmeldung-faa-rz"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "Mitarbeitergespr\u00e4che",
                                "is_external": false,
                                "internal_path": "/node/118",
                                "alias": "/mitarbeitergespraeche-rz"
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "Schulung / Weiterbildung",
                                "is_external": false,
                                "internal_path": "/node/119",
                                "alias": "/schulung-weiterbildung-rz"
                            },
                            {
                                "icon_id": null,
                                "weight": 7,
                                "title": "Personalbereitstellung",
                                "is_external": false,
                                "internal_path": "/node/120",
                                "alias": "/personalbereitstellung-rz"
                            },
                            {
                                "icon_id": null,
                                "weight": 8,
                                "title": "Teamkalender / interne Kalenderfreigabe",
                                "is_external": false,
                                "internal_path": "/node/121",
                                "alias": "/teamkalender-interne-kalenderfreigabe-rz"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 7,
                        "title": "Berichte aus den Handlungsbereichen / Bauabschnitten",
                        "is_external": false,
                        "internal_path": "/node/122",
                        "alias": "/berichte-aus-den-handlungsbereichen-bauabschnitten"
                    },
                    {
                        "icon_id": null,
                        "weight": 8,
                        "title": "Interne Prozesse",
                        "is_external": false,
                        "internal_path": "/node/123",
                        "alias": "/interne-prozesse-rz"
                    },
                    {
                        "icon_id": null,
                        "weight": 10,
                        "title": "Dokumentenbezeichnung",
                        "is_external": false,
                        "internal_path": "/node/124",
                        "alias": "/dokumentenbezeichnung-rz"
                    },
                    {
                        "icon_id": null,
                        "weight": 11,
                        "title": "Vorlagen",
                        "is_external": false,
                        "internal_path": "/node/125",
                        "alias": "/vorlagen-rz"
                    },
                    {
                        "icon_id": null,
                        "weight": 12,
                        "title": "Software",
                        "is_external": false,
                        "internal_path": "/node/126",
                        "alias": "/software-rz"
                    }
                ]
            },
            {
                "icon_id": "Infoportal",
                "weight": -42,
                "title": "Infoportal",
                "is_external": false,
                "internal_path": "/node/332",
                "alias": "/infoportal",
                "children": [
                    {
                        "icon_id": null,
                        "weight": 0,
                        "title": "Infoportal \u00dcbersicht",
                        "is_external": false,
                        "internal_path": "/node/332",
                        "alias": "/infoportal"
                    },
                    {
                        "icon_id": null,
                        "weight": 1,
                        "title": "Richtlinien",
                        "is_external": false,
                        "internal_path": "/node/200",
                        "alias": "/richtlinien"
                    },
                    {
                        "icon_id": null,
                        "weight": 3,
                        "title": "Prozesse und projektspezifische Workflows",
                        "is_external": false,
                        "internal_path": "/node/155",
                        "alias": "/prozesse-uebersicht",
                        "children": [
                            {
                                "icon_id": null,
                                "weight": 0,
                                "title": "\u00dcbersicht",
                                "is_external": false,
                                "internal_path": "/node/155",
                                "alias": "/prozesse-uebersicht"
                            },
                            {
                                "icon_id": null,
                                "weight": 1,
                                "title": "B-Organisation",
                                "is_external": false,
                                "internal_path": "/node/144",
                                "alias": "/prozesse-b-organisation"
                            },
                            {
                                "icon_id": null,
                                "weight": 2,
                                "title": "C-Kosten",
                                "is_external": false,
                                "internal_path": "/node/147",
                                "alias": "/prozesse-c-kosten"
                            },
                            {
                                "icon_id": null,
                                "weight": 3,
                                "title": "D-Termine",
                                "is_external": false,
                                "internal_path": "/node/148",
                                "alias": "/prozesse-d-termine"
                            },
                            {
                                "icon_id": null,
                                "weight": 4,
                                "title": "E-Vertr\u00e4ge",
                                "is_external": false,
                                "internal_path": "/node/379",
                                "alias": "/prozesse-e-vertraege"
                            },
                            {
                                "icon_id": null,
                                "weight": 5,
                                "title": "F-Planlauf",
                                "is_external": false,
                                "internal_path": "/node/150",
                                "alias": "/prozesse-f-planlauf"
                            },
                            {
                                "icon_id": null,
                                "weight": 6,
                                "title": "H-Risikomanagement",
                                "is_external": false,
                                "internal_path": "/node/151",
                                "alias": "/prozesse-h-risikomanagement"
                            }
                        ]
                    },
                    {
                        "icon_id": null,
                        "weight": 4,
                        "title": "Dokumentencodierung",
                        "is_external": false,
                        "internal_path": "/node/370",
                        "alias": "/dokumentencodierung"
                    },
                    {
                        "icon_id": null,
                        "weight": 8,
                        "title": "Zweck und Geltungsbereich",
                        "is_external": false,
                        "internal_path": "/node/276",
                        "alias": "/zweck-und-geltungsbereich"
                    },
                    {
                        "icon_id": null,
                        "weight": 9,
                        "title": "Abk\u00fcrzungsverzeichnis",
                        "is_external": false,
                        "internal_path": "/node/296",
                        "alias": "/abkuerzungsverzeichnis"
                    },
                    {
                        "icon_id": null,
                        "weight": 10,
                        "title": "Weiterf\u00fchrende Links",
                        "is_external": false,
                        "internal_path": "/node/202",
                        "alias": "/weiterfuehrende-links"
                    },
                    {
                        "icon_id": null,
                        "weight": 12,
                        "title": "Vertraulichkeit",
                        "is_external": false,
                        "internal_path": "/node/190",
                        "alias": "/vertraulichkeit"
                    },
                    {
                        "icon_id": null,
                        "weight": 13,
                        "title": "Datenschutzerkl\u00e4rung",
                        "is_external": false,
                        "internal_path": "/node/275",
                        "alias": "/datenschutzerklaerung"
                    },
                    {
                        "icon_id": null,
                        "weight": 14,
                        "title": "Baustelle / Bauma\u00dfnahme vorbereiten - Kabel",
                        "is_external": false,
                        "internal_path": "/node/401",
                        "alias": "/baustelle_bauma\u00dfnahme_vorbereiten-kabel"
                    }
                ]
            },
            {
                "icon_id": "Tools",
                "weight": -41,
                "title": "Tools",
                "is_external": false,
                "internal_path": "/node/195",
                "alias": "/tools-uebersicht",
                "children": [
                    {
                        "icon_id": null,
                        "weight": 0,
                        "title": "Tools \u00dcbersicht",
                        "is_external": false,
                        "internal_path": "/node/195",
                        "alias": "/tools-uebersicht"
                    },
                    {
                        "icon_id": null,
                        "weight": 1,
                        "title": "Managementboard",
                        "is_external": false,
                        "internal_path": "/node/299",
                        "alias": "/managementboard"
                    },
                    {
                        "icon_id": null,
                        "weight": 9,
                        "title": "Project Online",
                        "is_external": false,
                        "internal_path": "/node/305",
                        "alias": "/project-online"
                    },
                    {
                        "icon_id": null,
                        "weight": 10,
                        "title": "Digitales Projekthandbuch",
                        "is_external": false,
                        "internal_path": "/node/304",
                        "alias": "/digitales-projekthandbuch"
                    },
                    {
                        "icon_id": null,
                        "weight": 11,
                        "title": "InGe-Tool",
                        "is_external": false,
                        "internal_path": "/node/387",
                        "alias": "/inge-tool"
                    },
                    {
                        "icon_id": null,
                        "weight": 12,
                        "title": "Tilos",
                        "is_external": false,
                        "internal_path": "/node/284",
                        "alias": "/tilos"
                    },
                    {
                        "icon_id": null,
                        "weight": 13,
                        "title": "EPLASS",
                        "is_external": false,
                        "internal_path": "/node/285",
                        "alias": "/eplass"
                    },
                    {
                        "icon_id": null,
                        "weight": 14,
                        "title": "DOXiS",
                        "is_external": false,
                        "internal_path": "/node/286",
                        "alias": "/doxis"
                    },
                    {
                        "icon_id": null,
                        "weight": 15,
                        "title": "iTWO",
                        "is_external": false,
                        "internal_path": "/node/287",
                        "alias": "/itwo"
                    },
                    {
                        "icon_id": null,
                        "weight": 17,
                        "title": "BIM",
                        "is_external": false,
                        "internal_path": "/node/289",
                        "alias": "/bim"
                    },
                    {
                        "icon_id": null,
                        "weight": 18,
                        "title": "is.base",
                        "is_external": false,
                        "internal_path": "/node/290",
                        "alias": "/is-base"
                    },
                    {
                        "icon_id": null,
                        "weight": 19,
                        "title": "IT Serviceportal",
                        "is_external": false,
                        "internal_path": "/node/291",
                        "alias": "/it-serviceportal"
                    }
                ]
            }
        ]
    },
    "nid": 139,
    "langcode": "de",
    "type": "content_page",
    "user": [
        {
            "langcode": "de",
            "preferred_langcode": "de",
            "name": "v.fischer",
            "mail": "vfischer@rz2sbss.com",
            "timezone": "Europe/Berlin",
            "status": true,
            "changed": "2024-11-25T13:50:31+00:00",
            "access": "2025-04-22T06:06:28+00:00",
            "login": "2025-04-15T09:14:54+00:00",
            "roles": [
                {
                    "target_id": "administrator",
                    "field_name": "roles"
                },
                {
                    "target_id": "redakteur",
                    "field_name": "roles"
                },
                {
                    "target_id": "participant",
                    "field_name": "roles"
                },
                {
                    "target_id": "db",
                    "field_name": "roles"
                },
                {
                    "target_id": "rz",
                    "field_name": "roles"
                },
                {
                    "target_id": "buw",
                    "field_name": "roles"
                },
                {
                    "target_id": "bau",
                    "field_name": "roles"
                }
            ],
            "field_address": "Arnulfstra\u00dfe 50, 80335 M\u00fcnchen",
            "paragraph": [
                {
                    "id": 3050,
                    "langcode": "de",
                    "type": "company",
                    "status": true,
                    "parent_field_name": "field_company",
                    "field_company": "RZ 2.SBSS",
                    "taxonomy_term": [
                        {
                            "tid": 52,
                            "langcode": "de",
                            "status": true,
                            "name": "RZ 2. SBSS",
                            "weight": 49,
                            "RZ 2. SBSS": [
                                {
                                    "data": {
                                        "target_id": "0"
                                    },
                                    "field_name": "parent"
                                }
                            ],
                            "changed": "2024-08-21T07:05:05+00:00",
                            "path": [
                                {
                                    "alias": null,
                                    "pid": null,
                                    "langcode": "de",
                                    "lang": "de",
                                    "field_name": "path"
                                }
                            ],
                            "data": {
                                "target_id": "52"
                            },
                            "field_name": "field_company_term"
                        }
                    ],
                    "data": {
                        "target_id": "3050",
                        "target_revision_id": "31148"
                    },
                    "field_name": "field_company"
                },
                {
                    "id": 3051,
                    "langcode": "de",
                    "type": "roles",
                    "status": true,
                    "parent_field_name": "field_department_and_position",
                    "field_department": "AG Z - TPM / Zentrale Aufgaben",
                    "taxonomy_term": [
                        {
                            "tid": 92,
                            "langcode": "de",
                            "status": true,
                            "name": "ZA",
                            "weight": 32,
                            "ZA": [
                                {
                                    "data": {
                                        "target_id": "0"
                                    },
                                    "field_name": "parent"
                                }
                            ],
                            "changed": "2023-10-25T11:55:00+00:00",
                            "path": [
                                {
                                    "alias": null,
                                    "pid": null,
                                    "langcode": "de",
                                    "lang": "de",
                                    "field_name": "path"
                                }
                            ],
                            "data": {
                                "target_id": "92"
                            },
                            "field_name": "field_department_term"
                        }
                    ],
                    "field_position": "Assistenz, Administration Conclude, Schnittstellenmanagement., Administration Digitales Projekthandbuch, Gesamtdokumentation",
                    "data": {
                        "target_id": "3051",
                        "target_revision_id": "31149"
                    },
                    "field_name": "field_department_and_position"
                }
            ],
            "field_firstname": "Vanessa",
            "field_lastname": "Fischer",
            "field_mobile_number": "+49 151 443 555 37",
            "file": [
                {
                    "fid": 3269,
                    "langcode": "de",
                    "filename": "Vanessa-Fischer.jpg",
                    "uri": "public://pictures/2021-04/Vanessa-Fischer.jpg",
                    "url": "/sites/default/files/pictures/2021-04/Vanessa-Fischer.jpg",
                    "filemime": "image/jpeg",
                    "filesize": 103638,
                    "status": true,
                    "changed": "2021-04-12T14:16:47+00:00",
                    "date": "12.04.2021",
                    "data": {
                        "target_id": "3269",
                        "alt": "",
                        "title": "",
                        "width": "900",
                        "height": "560"
                    },
                    "field_name": "user_picture"
                }
            ],
            "data": {
                "target_id": "1484"
            },
            "field_name": "revision_uid"
        }
    ],
    "status": true,
    "title": "Entscheidungs- und \u00c4nderungsmanagement",
    "changed": "2024-01-22T13:34:57+00:00",
    "promote": false,
    "sticky": false,
    "path": [
        {
            "alias": "/entscheidungs-und-aenderungsmanagement",
            "pid": 129,
            "langcode": "de",
            "lang": "de",
            "field_name": "path"
        }
    ],
    "taxonomy_term": [
        {
            "tid": 3,
            "langcode": "de",
            "status": true,
            "name": "BUW",
            "weight": 0,
            "BUW": [
                {
                    "data": {
                        "target_id": "0"
                    },
                    "field_name": "parent"
                }
            ],
            "changed": "2019-08-07T13:11:31+00:00",
            "path": [
                {
                    "alias": null,
                    "pid": null,
                    "langcode": "de",
                    "field_name": "path"
                }
            ],
            "data": {
                "target_id": "3"
            },
            "field_name": "field_access"
        },
        {
            "tid": 1,
            "langcode": "de",
            "status": true,
            "name": "DB",
            "weight": 0,
            "DB": [
                {
                    "data": {
                        "target_id": "0"
                    },
                    "field_name": "parent"
                }
            ],
            "changed": "2019-08-07T13:10:45+00:00",
            "path": [
                {
                    "alias": null,
                    "pid": null,
                    "langcode": "de",
                    "field_name": "path"
                }
            ],
            "data": {
                "target_id": "1"
            },
            "field_name": "field_access"
        },
        {
            "tid": 2,
            "langcode": "de",
            "status": true,
            "name": "RZ",
            "weight": 0,
            "RZ": [
                {
                    "data": {
                        "target_id": "0"
                    },
                    "field_name": "parent"
                }
            ],
            "changed": "2019-08-07T13:11:18+00:00",
            "path": [
                {
                    "alias": null,
                    "pid": null,
                    "langcode": "de",
                    "field_name": "path"
                }
            ],
            "data": {
                "target_id": "2"
            },
            "field_name": "field_access"
        }
    ],
    "paragraph": [
        {
            "id": 1109,
            "langcode": "de",
            "type": "text_with_headline",
            "status": true,
            "parent_field_name": "field_paragraphs",
            "field_accordion": false,
            "field_default_open": false,
            "field_show_columns": false,
            "field_text": "<p>Entscheidungen k\u00f6nnen \u00fcber zwei Wege im Projekt offiziell eingeholt und dokumentiert werden:</p>\r\n",
            "data": {
                "target_id": "1109",
                "target_revision_id": "79374"
            },
            "lang": "de",
            "field_name": "field_paragraphs"
        },
        {
            "id": 1111,
            "langcode": "de",
            "type": "simple_image",
            "status": true,
            "parent_field_name": "field_paragraphs",
            "field_headline": "1. Entscheidungen \u00fcber Protokoll- und Aufgabenmanagement",
            "file": [
                {
                    "fid": 5425,
                    "langcode": "de",
                    "filename": "Entscheidungsmgmt_1.PNG",
                    "uri": "private://2023-08/Entscheidungsmgmt_1.PNG",
                    "url": "/system/files/2023-08/Entscheidungsmgmt_1.PNG",
                    "filemime": "image/png",
                    "filesize": 70891,
                    "status": true,
                    "changed": "2023-08-29T12:47:04+00:00",
                    "date": "29.08.2023",
                    "data": {
                        "target_id": "5425",
                        "alt": "",
                        "title": "",
                        "width": "1027",
                        "height": "606"
                    },
                    "lang": "de",
                    "field_name": "field_picture"
                }
            ],
            "field_text": "<p>Entscheidungen werden in einer Besprechung getroffen \u2192 Dokumentation als \u201eEntscheidung\u201c im Aufgaben- und Protokollmanagement mit Kennzeichnung im entsprechenden Protokoll</p>\r\n",
            "data": {
                "target_id": "1111",
                "target_revision_id": "79375"
            },
            "lang": "de",
            "field_name": "field_paragraphs"
        },
        {
            "id": 1112,
            "langcode": "de",
            "type": "simple_image",
            "status": true,
            "parent_field_name": "field_paragraphs",
            "field_headline": "2. Entscheidung durch OEL, Bereichsleitung oder GPL",
            "file": [
                {
                    "fid": 5424,
                    "langcode": "de",
                    "filename": "Entscheidungsmanagement_Mgmtboard.PNG",
                    "uri": "private://2023-08/Entscheidungsmanagement_Mgmtboard.PNG",
                    "url": "/system/files/2023-08/Entscheidungsmanagement_Mgmtboard.PNG",
                    "filemime": "image/png",
                    "filesize": 58222,
                    "status": true,
                    "changed": "2023-08-29T12:45:17+00:00",
                    "date": "29.08.2023",
                    "data": {
                        "target_id": "5424",
                        "alt": "",
                        "title": "",
                        "width": "965",
                        "height": "522"
                    },
                    "lang": "de",
                    "field_name": "field_picture"
                }
            ],
            "field_text": "<p>Entscheidungen werden in einer Entscheidungsvorlage zusammengefasst und \u00fcber einen definierten Prozess im Rahmen des Managementtools \u201eEntscheidungs- und \u00c4nderungsmanagement\u201c beim OE-Leiter&nbsp;(OEL I.IIM XX), Bereichsleiter (OEL I.IIM X) oder Gesamtprojektleiter (GPL) zur Entscheidung vorgelegt.</p>\r\n",
            "data": {
                "target_id": "1112",
                "target_revision_id": "79376"
            },
            "lang": "de",
            "field_name": "field_paragraphs"
        },
        {
            "id": 1113,
            "langcode": "de",
            "type": "text_with_headline",
            "status": true,
            "parent_field_name": "field_paragraphs",
            "field_accordion": false,
            "field_default_open": false,
            "field_headline": "Allgemein",
            "field_show_columns": false,
            "field_text": "<p>Die Unterscheidung, wann welcher Entscheidungsweg genommen werden soll, wird durch die Wertgrenzen definiert. Im Zweifelsfall wird der Entscheidungsweg \u00fcber die Gesamtprojektleitung genommen.<br />\r\n<br />\r\nDie in der Besprechung getroffene Entscheidung kann innerhalb des Protokoll- und Aufgabenmanagement \u00fcber einen definierten Workflow zus\u00e4tzlich abgesichert werden. Die dann abgesicherte Entscheidung bekommt anschlie\u00dfend im Protokoll den Status \u201eabgesichert\u201c.<br />\r\n<br />\r\nEine Entscheidungsvorlage wird verwendet, um einen neuen Sachverhalt zur Entscheidung vorzulegen. Dieses betrifft z. B. die erstmalige Freigabe eines Terminplanes mit den darin enthaltenen Meilensteinen.<br />\r\n<br />\r\nWerden schon einmal entschiedene Sachverhalte ge\u00e4ndert, wie z. B. eine Plan\u00e4nderung, die Fortschreibung von relevanten Meilensteinen in der Terminplanung, wird unter Bezugnahme auf die urspr\u00fcngliche Freigabe eine \u00c4nderungsvorlage erstellt und zur Freigabe \u00fcber einen Workflow an die entsprechenden Entscheidungstr\u00e4ger weitergeleitet.</p>\r\n",
            "data": {
                "target_id": "1113",
                "target_revision_id": "79377"
            },
            "lang": "de",
            "field_name": "field_paragraphs"
        },
        {
            "id": 1114,
            "langcode": "de",
            "type": "text_with_headline",
            "status": true,
            "parent_field_name": "field_paragraphs",
            "field_accordion": false,
            "field_default_open": false,
            "field_headline": "Wertgrenzen f\u00fcr den Entscheidungsrahmen",
            "field_show_columns": false,
            "field_text": "<p>Wer in der Organisation der DB InfraGO AG Entscheidungen und \u00c4nderungsfreigabe grunds\u00e4tzlich treffen darf, richtet sich nach folgenden Wertgrenzen:</p>\r\n\r\n<ul>\r\n\t<li><strong>Entscheidungen im Rahmen des Protokoll- und Aufgabenmanagements \u00fcber den Eintrag \u201eEntscheidung\u201c:</strong>\r\n\r\n\t<ul>\r\n\t\t<li>Ohne Auswirkungen&nbsp;auf Kosten und Termine</li>\r\n\t\t<li>Ohne Relevanz auf Inbetriebnahmetermin</li>\r\n\t\t<li>Entscheidung, welche auf Teamleiterebene getroffen werden kann</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>Entscheidungen im Rahmen des Entscheidungs- und \u00c4nderungsmanagements auf Ebene des OEL I.IIM XX:</strong>\r\n\t<ul>\r\n\t\t<li>Ohne Auswirkungen&nbsp;auf Kosten und Termine</li>\r\n\t\t<li>Bezug zum Bauabschnitt bzw. Teilprojekt</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>Entscheidungen im Rahmen des Entscheidungs- und \u00c4nderungsmanagements auf Ebene des OEL I.IIM X (Bereichsleiter):</strong>\r\n\t<ul>\r\n\t\t<li>\u2264 15 Mio. \u20ac Baukosten netto</li>\r\n\t\t<li>1 Monat und \u2264 3 Monate Verz\u00f6gerung</li>\r\n\t\t<li>Ohne Relevanz auf den Inbetriebnahmetermin (Gesamtprojekt)</li>\r\n\t</ul>\r\n\t</li>\r\n\t<li><strong>Entscheidungen im Rahmen des Entscheidungs- und \u00c4nderungsmanagements auf Ebene des GPL:</strong>\r\n\t<ul>\r\n\t\t<li>15 \u2264 50&nbsp;Mio. \u20ac Baukosten netto</li>\r\n\t\t<li>Mind. 3 Monate Verz\u00f6gerung</li>\r\n\t\t<li>Mit ggf. Relevanz auf den Inbetriebnahmetermin (Gesamtprojekt)</li>\r\n\t</ul>\r\n\t</li>\r\n</ul>\r\n",
            "data": {
                "target_id": "1114",
                "target_revision_id": "79378"
            },
            "lang": "de",
            "field_name": "field_paragraphs"
        },
        {
            "id": 6432,
            "langcode": "de",
            "type": "cards",
            "status": true,
            "parent_field_name": "field_paragraphs",
            "paragraph": [
                {
                    "id": 6430,
                    "langcode": "de",
                    "type": "image_headline_text_link",
                    "status": true,
                    "parent_field_name": "field_cards",
                    "field_headline": "Prozesse Entscheidungs- und \u00c4nderungsmanagement",
                    "field_image_left": false,
                    "field_link": [
                        {
                            "uri": "entity:node/144",
                            "external": false,
                            "path": "/node/144",
                            "alias": "/prozesse-b-organisation",
                            "title": "",
                            "options": [],
                            "lang": "de",
                            "field_name": "field_link"
                        }
                    ],
                    "field_text": "<p>Die Workflows, die diesen Wertgrenzen zugeordnet sind, gestalten sich wie folgt.</p>\r\n",
                    "data": {
                        "target_id": "6430",
                        "target_revision_id": "79379"
                    },
                    "lang": "de",
                    "field_name": "field_cards"
                },
                {
                    "id": 6431,
                    "langcode": "de",
                    "type": "image_headline_text_link",
                    "status": true,
                    "parent_field_name": "field_cards",
                    "field_headline": "Schulungsunterlagen \u201eEntscheidungs- und \u00c4nderungsmanagement\u201c",
                    "field_image_left": false,
                    "field_link": [
                        {
                            "uri": "entity:node/299",
                            "external": false,
                            "path": "/node/299",
                            "alias": "/managementboard",
                            "title": "",
                            "options": [],
                            "lang": "de",
                            "field_name": "field_link"
                        }
                    ],
                    "field_text": "<p>N\u00e4here Informationen zum definierten Prozess im Rahmen des Entscheidungs- und \u00c4nderungsmanagement enthalten die Schulungsunterlagen zum&nbsp;Managementboard.</p>\r\n",
                    "data": {
                        "target_id": "6431",
                        "target_revision_id": "79380"
                    },
                    "lang": "de",
                    "field_name": "field_cards"
                }
            ],
            "data": {
                "target_id": "6432",
                "target_revision_id": "79381"
            },
            "lang": "de",
            "field_name": "field_paragraphs"
        },
        {
            "id": 1115,
            "langcode": "de",
            "type": "text_with_headline",
            "status": true,
            "parent_field_name": "field_paragraphs",
            "field_accordion": false,
            "field_default_open": false,
            "field_headline": "Ansprechpartner",
            "field_show_columns": false,
            "field_text": "<p>F\u00fcr das projekt\u00fcbergreifende Entscheidungs- und \u00c4nderungsmanagement sind folgende Personen Ansprechpartner:</p>\r\n\r\n<p><strong>Zentrale Aufgaben, Entscheidungs- und \u00c4nderungsmanagement DB InfraGO AG, 2. S-Bahn-Stammstrecke M\u00fcnchen</strong></p>\r\n\r\n<p>Herr Harald Graser<br />\r\nE-mail: <a href=\"mailto:harald.graser@deutschebahn.com\">harald.graser@deutschebahn.com</a><br />\r\nTel. +49 89 1308 83123<br />\r\n&nbsp;</p>\r\n\r\n<p><strong>Realisierungszentrum, Entscheidungs- und \u00c4nderungsmanagement</strong><br />\r\n<br />\r\nHerr Florian Gr\u00e4ser<br />\r\nE-Mail: <a href=\"mailto:graeser@rz2sbss.com\">graeser@rz2sbss.com</a><br />\r\nTel.: +49 160 93118705</p>\r\n",
            "data": {
                "target_id": "1115",
                "target_revision_id": "79382"
            },
            "lang": "de",
            "field_name": "field_paragraphs"
        }
    ]
}
